<template lang="pug">
v-container.px-0.mx-0.mt-n7
  v-window(v-model="window").mb-4
    v-window-item
      v-btn(large block outlined @click="window = 1") Создать категорию
    v-window-item
      v-text-field(
        v-model="name"
        label="Название категории" dense
        rounded filled hide-details
      )
        template(v-slot:prepend)
          tooltip-wrap(text="Отмена")
            v-btn(
              fab x-small depressed
              color="error"
              :loading="loading"
              @click="window = 0"
            ): v-icon mdi-close
        template(v-slot:append-outer)
          tooltip-wrap(text="Сохранить")
            v-btn(
              fab x-small depressed
              color="success"
              :loading="loading"
              @click="save"
            ): v-icon mdi-check
  server-data(
    ref="serverData"
    v-slot:default="{ serverData, selectProps, loadMoreItems, loading }"
    :method="(val) => $api.mentoring.getCategories(val)"
    :query="query"
  )
     data-wrapper(
      :loading="loading"
      :skeleton-items-count="4"
      :has-items="!!serverData.length"
      skeleton-type="paragraph"
      :colsProps="{ cols: 12, md: 12, sm: 12, xl: 12 }"
    )
      template(#no-data)
        v-alert(
          type="info" prominent text
        ).mx-auto Еще нет категорий
      template(#default)
        v-list
          v-list-item(
            v-for="item in serverData"
            :key="item.id"
          )
            v-list-item-content
              h4 {{ item.name }}
              .text-caption
                | Анкета:
                v-btn(
                  v-if="item.organization_questionnaires || true"
                  small text color="primary"
                ) {{ item.organization_questionnaires }}
                //- v-btn(icon small color="primary"): v-icon(small) mdi-pencil
              v-chip-group
                v-chip(small color="secondary" outlined).pr-0 Наставники:
                  v-chip(small color="secondary").ml-2.mr-0
                    | {{ item.mentors && item.mentors.length || 0 }}
                v-chip(small color="secondary" outlined).pr-0 Практики:
                  v-chip(small color="secondary").ml-2.mr-0
                    | {{ item.pages && item.pages.length || 0 }}
                v-chip(small color="secondary" outlined).pr-0 Программы:
                  v-chip(small color="secondary").ml-2.mr-0
                    | {{ item.course_recommendations && item.course_recommendations.length || 0 }}
            v-list-item-action
              v-btn(icon): v-icon mdi-menu
</template>
<script>
import DataWrapper from '@/components/DataWrapper.vue';

export default {
  components: {
    DataWrapper,
  },
  data() {
    return {
      window: 0,
      loading: false,
      name: '',
      query: {
        expand: 'pages,course_recommendations,mentors,mentoring_request,organization_questionnaires,questionnaire_organizations',
      },
    };
  },
  methods: {
    async save() {
      this.loading = true;
      const { name } = this;
      await this.$api.mentoring.createCategories({ name });
      this.window = 0;
      this.$refs.serverData.init();
      this.loading = false;
    },
  },
};
</script>
